/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PageVoiceResponseDTO } from '../models';
// @ts-ignore
import type { VoiceCreateDTO } from '../models';
// @ts-ignore
import type { VoiceResponseDTO } from '../models';
// @ts-ignore
import type { VoiceSampleRequestDTO } from '../models';
// @ts-ignore
import type { VoiceUpdateDTO } from '../models';
/**
 * VoicesApi - axios parameter creator
 * @export
 */
export const VoicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new voice (catalog curation; requires \'voice:admin\'). Requires a unique ElevenLabs voice ID.
         * @summary Create Voice
         * @param {VoiceCreateDTO} voiceCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVoiceApiV1VoicesPost: async (voiceCreateDTO: VoiceCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voiceCreateDTO' is not null or undefined
            assertParamExists('createVoiceApiV1VoicesPost', 'voiceCreateDTO', voiceCreateDTO)
            const localVarPath = `/api/v1/voices/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voiceCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new voice (catalog curation; requires \'voice:admin\'). Requires a unique ElevenLabs voice ID.
         * @summary Create Voice
         * @param {VoiceCreateDTO} voiceCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVoiceApiV1VoicesPost_1: async (voiceCreateDTO: VoiceCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voiceCreateDTO' is not null or undefined
            assertParamExists('createVoiceApiV1VoicesPost_1', 'voiceCreateDTO', voiceCreateDTO)
            const localVarPath = `/api/v1/voices/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voiceCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a voice (catalog curation; requires \'voice:admin\').  A voice that is still assigned to agents is only deleted when `replacement_voice_id` names another voice to move those agents to.
         * @summary Delete Voice
         * @param {string} voiceId 
         * @param {string | null} [replacementVoiceId] Voice that takes over all agents currently assigned to the deleted voice. Without it, deleting a voice that is still in use fails with 409 VOICE_IN_USE.
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVoiceApiV1VoicesVoiceIdDelete: async (voiceId: string, replacementVoiceId?: string | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voiceId' is not null or undefined
            assertParamExists('deleteVoiceApiV1VoicesVoiceIdDelete', 'voiceId', voiceId)
            const localVarPath = `/api/v1/voices/{voice_id}`
                .replace(`{${"voice_id"}}`, encodeURIComponent(String(voiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (replacementVoiceId !== undefined) {
                localVarQueryParameter['replacement_voice_id'] = replacementVoiceId;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a voice (catalog curation; requires \'voice:admin\').  A voice that is still assigned to agents is only deleted when `replacement_voice_id` names another voice to move those agents to.
         * @summary Delete Voice
         * @param {string} voiceId 
         * @param {string | null} [replacementVoiceId] Voice that takes over all agents currently assigned to the deleted voice. Without it, deleting a voice that is still in use fails with 409 VOICE_IN_USE.
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVoiceApiV1VoicesVoiceIdDelete_2: async (voiceId: string, replacementVoiceId?: string | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voiceId' is not null or undefined
            assertParamExists('deleteVoiceApiV1VoicesVoiceIdDelete_2', 'voiceId', voiceId)
            const localVarPath = `/api/v1/voices/{voice_id}`
                .replace(`{${"voice_id"}}`, encodeURIComponent(String(voiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (replacementVoiceId !== undefined) {
                localVarQueryParameter['replacement_voice_id'] = replacementVoiceId;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove the voice\'s portrait image (requires \'voice:admin\').
         * @summary Delete Voice Image
         * @param {string} voiceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVoiceImageApiV1VoicesVoiceIdImageDelete: async (voiceId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voiceId' is not null or undefined
            assertParamExists('deleteVoiceImageApiV1VoicesVoiceIdImageDelete', 'voiceId', voiceId)
            const localVarPath = `/api/v1/voices/{voice_id}/image`
                .replace(`{${"voice_id"}}`, encodeURIComponent(String(voiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove the voice\'s portrait image (requires \'voice:admin\').
         * @summary Delete Voice Image
         * @param {string} voiceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVoiceImageApiV1VoicesVoiceIdImageDelete_3: async (voiceId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voiceId' is not null or undefined
            assertParamExists('deleteVoiceImageApiV1VoicesVoiceIdImageDelete_3', 'voiceId', voiceId)
            const localVarPath = `/api/v1/voices/{voice_id}/image`
                .replace(`{${"voice_id"}}`, encodeURIComponent(String(voiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate a voice sample using ElevenLabs TTS. Returns an audio file with the provided text spoken in the selected voice.
         * @summary Generate Voice Sample
         * @param {string} voiceId 
         * @param {VoiceSampleRequestDTO} voiceSampleRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateVoiceSampleApiV1VoicesVoiceIdSamplePost: async (voiceId: string, voiceSampleRequestDTO: VoiceSampleRequestDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voiceId' is not null or undefined
            assertParamExists('generateVoiceSampleApiV1VoicesVoiceIdSamplePost', 'voiceId', voiceId)
            // verify required parameter 'voiceSampleRequestDTO' is not null or undefined
            assertParamExists('generateVoiceSampleApiV1VoicesVoiceIdSamplePost', 'voiceSampleRequestDTO', voiceSampleRequestDTO)
            const localVarPath = `/api/v1/voices/{voice_id}/sample`
                .replace(`{${"voice_id"}}`, encodeURIComponent(String(voiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voiceSampleRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate a voice sample using ElevenLabs TTS. Returns an audio file with the provided text spoken in the selected voice.
         * @summary Generate Voice Sample
         * @param {string} voiceId 
         * @param {VoiceSampleRequestDTO} voiceSampleRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateVoiceSampleApiV1VoicesVoiceIdSamplePost_4: async (voiceId: string, voiceSampleRequestDTO: VoiceSampleRequestDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voiceId' is not null or undefined
            assertParamExists('generateVoiceSampleApiV1VoicesVoiceIdSamplePost_4', 'voiceId', voiceId)
            // verify required parameter 'voiceSampleRequestDTO' is not null or undefined
            assertParamExists('generateVoiceSampleApiV1VoicesVoiceIdSamplePost_4', 'voiceSampleRequestDTO', voiceSampleRequestDTO)
            const localVarPath = `/api/v1/voices/{voice_id}/sample`
                .replace(`{${"voice_id"}}`, encodeURIComponent(String(voiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voiceSampleRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific voice by ID.
         * @summary Get Voice
         * @param {string} voiceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoiceApiV1VoicesVoiceIdGet: async (voiceId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voiceId' is not null or undefined
            assertParamExists('getVoiceApiV1VoicesVoiceIdGet', 'voiceId', voiceId)
            const localVarPath = `/api/v1/voices/{voice_id}`
                .replace(`{${"voice_id"}}`, encodeURIComponent(String(voiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific voice by ID.
         * @summary Get Voice
         * @param {string} voiceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoiceApiV1VoicesVoiceIdGet_5: async (voiceId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voiceId' is not null or undefined
            assertParamExists('getVoiceApiV1VoicesVoiceIdGet_5', 'voiceId', voiceId)
            const localVarPath = `/api/v1/voices/{voice_id}`
                .replace(`{${"voice_id"}}`, encodeURIComponent(String(voiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all available voices. Voices are global resources not tied to any organization.
         * @summary List Voices
         * @param {boolean} [activeOnly] Only return active voices
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVoicesApiV1VoicesGet: async (activeOnly?: boolean, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/voices/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (activeOnly !== undefined) {
                localVarQueryParameter['active_only'] = activeOnly;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all available voices. Voices are global resources not tied to any organization.
         * @summary List Voices
         * @param {boolean} [activeOnly] Only return active voices
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVoicesApiV1VoicesGet_6: async (activeOnly?: boolean, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/voices/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (activeOnly !== undefined) {
                localVarQueryParameter['active_only'] = activeOnly;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search voices by name.
         * @summary Search Voices
         * @param {string} name Search term for voice name
         * @param {number} [limit] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchVoicesApiV1VoicesSearchGet: async (name: string, limit?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('searchVoicesApiV1VoicesSearchGet', 'name', name)
            const localVarPath = `/api/v1/voices/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search voices by name.
         * @summary Search Voices
         * @param {string} name Search term for voice name
         * @param {number} [limit] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchVoicesApiV1VoicesSearchGet_7: async (name: string, limit?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('searchVoicesApiV1VoicesSearchGet_7', 'name', name)
            const localVarPath = `/api/v1/voices/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload (or replace) the voice\'s portrait image (requires \'voice:admin\').  Format and size limits are enforced by the service. The returned DTO includes the resulting ``image_url``.
         * @summary Set Voice Image
         * @param {string} voiceId 
         * @param {string} file 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setVoiceImageApiV1VoicesVoiceIdImagePut: async (voiceId: string, file: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voiceId' is not null or undefined
            assertParamExists('setVoiceImageApiV1VoicesVoiceIdImagePut', 'voiceId', voiceId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('setVoiceImageApiV1VoicesVoiceIdImagePut', 'file', file)
            const localVarPath = `/api/v1/voices/{voice_id}/image`
                .replace(`{${"voice_id"}}`, encodeURIComponent(String(voiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload (or replace) the voice\'s portrait image (requires \'voice:admin\').  Format and size limits are enforced by the service. The returned DTO includes the resulting ``image_url``.
         * @summary Set Voice Image
         * @param {string} voiceId 
         * @param {string} file 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setVoiceImageApiV1VoicesVoiceIdImagePut_8: async (voiceId: string, file: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voiceId' is not null or undefined
            assertParamExists('setVoiceImageApiV1VoicesVoiceIdImagePut_8', 'voiceId', voiceId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('setVoiceImageApiV1VoicesVoiceIdImagePut_8', 'file', file)
            const localVarPath = `/api/v1/voices/{voice_id}/image`
                .replace(`{${"voice_id"}}`, encodeURIComponent(String(voiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a voice\'s information (catalog curation; requires \'voice:admin\').
         * @summary Update Voice
         * @param {string} voiceId 
         * @param {VoiceUpdateDTO} voiceUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVoiceApiV1VoicesVoiceIdPatch: async (voiceId: string, voiceUpdateDTO: VoiceUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voiceId' is not null or undefined
            assertParamExists('updateVoiceApiV1VoicesVoiceIdPatch', 'voiceId', voiceId)
            // verify required parameter 'voiceUpdateDTO' is not null or undefined
            assertParamExists('updateVoiceApiV1VoicesVoiceIdPatch', 'voiceUpdateDTO', voiceUpdateDTO)
            const localVarPath = `/api/v1/voices/{voice_id}`
                .replace(`{${"voice_id"}}`, encodeURIComponent(String(voiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voiceUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a voice\'s information (catalog curation; requires \'voice:admin\').
         * @summary Update Voice
         * @param {string} voiceId 
         * @param {VoiceUpdateDTO} voiceUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVoiceApiV1VoicesVoiceIdPatch_9: async (voiceId: string, voiceUpdateDTO: VoiceUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voiceId' is not null or undefined
            assertParamExists('updateVoiceApiV1VoicesVoiceIdPatch_9', 'voiceId', voiceId)
            // verify required parameter 'voiceUpdateDTO' is not null or undefined
            assertParamExists('updateVoiceApiV1VoicesVoiceIdPatch_9', 'voiceUpdateDTO', voiceUpdateDTO)
            const localVarPath = `/api/v1/voices/{voice_id}`
                .replace(`{${"voice_id"}}`, encodeURIComponent(String(voiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voiceUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VoicesApi - functional programming interface
 * @export
 */
export const VoicesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VoicesApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new voice (catalog curation; requires \'voice:admin\'). Requires a unique ElevenLabs voice ID.
         * @summary Create Voice
         * @param {VoiceCreateDTO} voiceCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVoiceApiV1VoicesPost(voiceCreateDTO: VoiceCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVoiceApiV1VoicesPost(voiceCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoicesApi.createVoiceApiV1VoicesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new voice (catalog curation; requires \'voice:admin\'). Requires a unique ElevenLabs voice ID.
         * @summary Create Voice
         * @param {VoiceCreateDTO} voiceCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVoiceApiV1VoicesPost_1(voiceCreateDTO: VoiceCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVoiceApiV1VoicesPost_1(voiceCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoicesApi.createVoiceApiV1VoicesPost_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a voice (catalog curation; requires \'voice:admin\').  A voice that is still assigned to agents is only deleted when `replacement_voice_id` names another voice to move those agents to.
         * @summary Delete Voice
         * @param {string} voiceId 
         * @param {string | null} [replacementVoiceId] Voice that takes over all agents currently assigned to the deleted voice. Without it, deleting a voice that is still in use fails with 409 VOICE_IN_USE.
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVoiceApiV1VoicesVoiceIdDelete(voiceId: string, replacementVoiceId?: string | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVoiceApiV1VoicesVoiceIdDelete(voiceId, replacementVoiceId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoicesApi.deleteVoiceApiV1VoicesVoiceIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a voice (catalog curation; requires \'voice:admin\').  A voice that is still assigned to agents is only deleted when `replacement_voice_id` names another voice to move those agents to.
         * @summary Delete Voice
         * @param {string} voiceId 
         * @param {string | null} [replacementVoiceId] Voice that takes over all agents currently assigned to the deleted voice. Without it, deleting a voice that is still in use fails with 409 VOICE_IN_USE.
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVoiceApiV1VoicesVoiceIdDelete_2(voiceId: string, replacementVoiceId?: string | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVoiceApiV1VoicesVoiceIdDelete_2(voiceId, replacementVoiceId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoicesApi.deleteVoiceApiV1VoicesVoiceIdDelete_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove the voice\'s portrait image (requires \'voice:admin\').
         * @summary Delete Voice Image
         * @param {string} voiceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVoiceImageApiV1VoicesVoiceIdImageDelete(voiceId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVoiceImageApiV1VoicesVoiceIdImageDelete(voiceId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoicesApi.deleteVoiceImageApiV1VoicesVoiceIdImageDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove the voice\'s portrait image (requires \'voice:admin\').
         * @summary Delete Voice Image
         * @param {string} voiceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVoiceImageApiV1VoicesVoiceIdImageDelete_3(voiceId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVoiceImageApiV1VoicesVoiceIdImageDelete_3(voiceId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoicesApi.deleteVoiceImageApiV1VoicesVoiceIdImageDelete_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate a voice sample using ElevenLabs TTS. Returns an audio file with the provided text spoken in the selected voice.
         * @summary Generate Voice Sample
         * @param {string} voiceId 
         * @param {VoiceSampleRequestDTO} voiceSampleRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateVoiceSampleApiV1VoicesVoiceIdSamplePost(voiceId: string, voiceSampleRequestDTO: VoiceSampleRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateVoiceSampleApiV1VoicesVoiceIdSamplePost(voiceId, voiceSampleRequestDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoicesApi.generateVoiceSampleApiV1VoicesVoiceIdSamplePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate a voice sample using ElevenLabs TTS. Returns an audio file with the provided text spoken in the selected voice.
         * @summary Generate Voice Sample
         * @param {string} voiceId 
         * @param {VoiceSampleRequestDTO} voiceSampleRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateVoiceSampleApiV1VoicesVoiceIdSamplePost_4(voiceId: string, voiceSampleRequestDTO: VoiceSampleRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateVoiceSampleApiV1VoicesVoiceIdSamplePost_4(voiceId, voiceSampleRequestDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoicesApi.generateVoiceSampleApiV1VoicesVoiceIdSamplePost_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific voice by ID.
         * @summary Get Voice
         * @param {string} voiceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVoiceApiV1VoicesVoiceIdGet(voiceId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVoiceApiV1VoicesVoiceIdGet(voiceId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoicesApi.getVoiceApiV1VoicesVoiceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific voice by ID.
         * @summary Get Voice
         * @param {string} voiceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVoiceApiV1VoicesVoiceIdGet_5(voiceId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVoiceApiV1VoicesVoiceIdGet_5(voiceId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoicesApi.getVoiceApiV1VoicesVoiceIdGet_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all available voices. Voices are global resources not tied to any organization.
         * @summary List Voices
         * @param {boolean} [activeOnly] Only return active voices
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listVoicesApiV1VoicesGet(activeOnly?: boolean, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageVoiceResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listVoicesApiV1VoicesGet(activeOnly, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoicesApi.listVoicesApiV1VoicesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all available voices. Voices are global resources not tied to any organization.
         * @summary List Voices
         * @param {boolean} [activeOnly] Only return active voices
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listVoicesApiV1VoicesGet_6(activeOnly?: boolean, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageVoiceResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listVoicesApiV1VoicesGet_6(activeOnly, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoicesApi.listVoicesApiV1VoicesGet_6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search voices by name.
         * @summary Search Voices
         * @param {string} name Search term for voice name
         * @param {number} [limit] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchVoicesApiV1VoicesSearchGet(name: string, limit?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VoiceResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchVoicesApiV1VoicesSearchGet(name, limit, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoicesApi.searchVoicesApiV1VoicesSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search voices by name.
         * @summary Search Voices
         * @param {string} name Search term for voice name
         * @param {number} [limit] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchVoicesApiV1VoicesSearchGet_7(name: string, limit?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VoiceResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchVoicesApiV1VoicesSearchGet_7(name, limit, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoicesApi.searchVoicesApiV1VoicesSearchGet_7']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload (or replace) the voice\'s portrait image (requires \'voice:admin\').  Format and size limits are enforced by the service. The returned DTO includes the resulting ``image_url``.
         * @summary Set Voice Image
         * @param {string} voiceId 
         * @param {string} file 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setVoiceImageApiV1VoicesVoiceIdImagePut(voiceId: string, file: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setVoiceImageApiV1VoicesVoiceIdImagePut(voiceId, file, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoicesApi.setVoiceImageApiV1VoicesVoiceIdImagePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload (or replace) the voice\'s portrait image (requires \'voice:admin\').  Format and size limits are enforced by the service. The returned DTO includes the resulting ``image_url``.
         * @summary Set Voice Image
         * @param {string} voiceId 
         * @param {string} file 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setVoiceImageApiV1VoicesVoiceIdImagePut_8(voiceId: string, file: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setVoiceImageApiV1VoicesVoiceIdImagePut_8(voiceId, file, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoicesApi.setVoiceImageApiV1VoicesVoiceIdImagePut_8']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a voice\'s information (catalog curation; requires \'voice:admin\').
         * @summary Update Voice
         * @param {string} voiceId 
         * @param {VoiceUpdateDTO} voiceUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVoiceApiV1VoicesVoiceIdPatch(voiceId: string, voiceUpdateDTO: VoiceUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVoiceApiV1VoicesVoiceIdPatch(voiceId, voiceUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoicesApi.updateVoiceApiV1VoicesVoiceIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a voice\'s information (catalog curation; requires \'voice:admin\').
         * @summary Update Voice
         * @param {string} voiceId 
         * @param {VoiceUpdateDTO} voiceUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVoiceApiV1VoicesVoiceIdPatch_9(voiceId: string, voiceUpdateDTO: VoiceUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVoiceApiV1VoicesVoiceIdPatch_9(voiceId, voiceUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoicesApi.updateVoiceApiV1VoicesVoiceIdPatch_9']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VoicesApi - factory interface
 * @export
 */
export const VoicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VoicesApiFp(configuration)
    return {
        /**
         * Create a new voice (catalog curation; requires \'voice:admin\'). Requires a unique ElevenLabs voice ID.
         * @summary Create Voice
         * @param {VoiceCreateDTO} voiceCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVoiceApiV1VoicesPost(voiceCreateDTO: VoiceCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<VoiceResponseDTO> {
            return localVarFp.createVoiceApiV1VoicesPost(voiceCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new voice (catalog curation; requires \'voice:admin\'). Requires a unique ElevenLabs voice ID.
         * @summary Create Voice
         * @param {VoiceCreateDTO} voiceCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVoiceApiV1VoicesPost_1(voiceCreateDTO: VoiceCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<VoiceResponseDTO> {
            return localVarFp.createVoiceApiV1VoicesPost_1(voiceCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a voice (catalog curation; requires \'voice:admin\').  A voice that is still assigned to agents is only deleted when `replacement_voice_id` names another voice to move those agents to.
         * @summary Delete Voice
         * @param {string} voiceId 
         * @param {string | null} [replacementVoiceId] Voice that takes over all agents currently assigned to the deleted voice. Without it, deleting a voice that is still in use fails with 409 VOICE_IN_USE.
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVoiceApiV1VoicesVoiceIdDelete(voiceId: string, replacementVoiceId?: string | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteVoiceApiV1VoicesVoiceIdDelete(voiceId, replacementVoiceId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a voice (catalog curation; requires \'voice:admin\').  A voice that is still assigned to agents is only deleted when `replacement_voice_id` names another voice to move those agents to.
         * @summary Delete Voice
         * @param {string} voiceId 
         * @param {string | null} [replacementVoiceId] Voice that takes over all agents currently assigned to the deleted voice. Without it, deleting a voice that is still in use fails with 409 VOICE_IN_USE.
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVoiceApiV1VoicesVoiceIdDelete_2(voiceId: string, replacementVoiceId?: string | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteVoiceApiV1VoicesVoiceIdDelete_2(voiceId, replacementVoiceId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove the voice\'s portrait image (requires \'voice:admin\').
         * @summary Delete Voice Image
         * @param {string} voiceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVoiceImageApiV1VoicesVoiceIdImageDelete(voiceId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteVoiceImageApiV1VoicesVoiceIdImageDelete(voiceId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove the voice\'s portrait image (requires \'voice:admin\').
         * @summary Delete Voice Image
         * @param {string} voiceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVoiceImageApiV1VoicesVoiceIdImageDelete_3(voiceId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteVoiceImageApiV1VoicesVoiceIdImageDelete_3(voiceId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate a voice sample using ElevenLabs TTS. Returns an audio file with the provided text spoken in the selected voice.
         * @summary Generate Voice Sample
         * @param {string} voiceId 
         * @param {VoiceSampleRequestDTO} voiceSampleRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateVoiceSampleApiV1VoicesVoiceIdSamplePost(voiceId: string, voiceSampleRequestDTO: VoiceSampleRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.generateVoiceSampleApiV1VoicesVoiceIdSamplePost(voiceId, voiceSampleRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate a voice sample using ElevenLabs TTS. Returns an audio file with the provided text spoken in the selected voice.
         * @summary Generate Voice Sample
         * @param {string} voiceId 
         * @param {VoiceSampleRequestDTO} voiceSampleRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateVoiceSampleApiV1VoicesVoiceIdSamplePost_4(voiceId: string, voiceSampleRequestDTO: VoiceSampleRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.generateVoiceSampleApiV1VoicesVoiceIdSamplePost_4(voiceId, voiceSampleRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific voice by ID.
         * @summary Get Voice
         * @param {string} voiceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoiceApiV1VoicesVoiceIdGet(voiceId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<VoiceResponseDTO> {
            return localVarFp.getVoiceApiV1VoicesVoiceIdGet(voiceId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific voice by ID.
         * @summary Get Voice
         * @param {string} voiceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoiceApiV1VoicesVoiceIdGet_5(voiceId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<VoiceResponseDTO> {
            return localVarFp.getVoiceApiV1VoicesVoiceIdGet_5(voiceId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all available voices. Voices are global resources not tied to any organization.
         * @summary List Voices
         * @param {boolean} [activeOnly] Only return active voices
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVoicesApiV1VoicesGet(activeOnly?: boolean, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageVoiceResponseDTO> {
            return localVarFp.listVoicesApiV1VoicesGet(activeOnly, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all available voices. Voices are global resources not tied to any organization.
         * @summary List Voices
         * @param {boolean} [activeOnly] Only return active voices
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVoicesApiV1VoicesGet_6(activeOnly?: boolean, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageVoiceResponseDTO> {
            return localVarFp.listVoicesApiV1VoicesGet_6(activeOnly, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Search voices by name.
         * @summary Search Voices
         * @param {string} name Search term for voice name
         * @param {number} [limit] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchVoicesApiV1VoicesSearchGet(name: string, limit?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<VoiceResponseDTO>> {
            return localVarFp.searchVoicesApiV1VoicesSearchGet(name, limit, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Search voices by name.
         * @summary Search Voices
         * @param {string} name Search term for voice name
         * @param {number} [limit] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchVoicesApiV1VoicesSearchGet_7(name: string, limit?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<VoiceResponseDTO>> {
            return localVarFp.searchVoicesApiV1VoicesSearchGet_7(name, limit, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload (or replace) the voice\'s portrait image (requires \'voice:admin\').  Format and size limits are enforced by the service. The returned DTO includes the resulting ``image_url``.
         * @summary Set Voice Image
         * @param {string} voiceId 
         * @param {string} file 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setVoiceImageApiV1VoicesVoiceIdImagePut(voiceId: string, file: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<VoiceResponseDTO> {
            return localVarFp.setVoiceImageApiV1VoicesVoiceIdImagePut(voiceId, file, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload (or replace) the voice\'s portrait image (requires \'voice:admin\').  Format and size limits are enforced by the service. The returned DTO includes the resulting ``image_url``.
         * @summary Set Voice Image
         * @param {string} voiceId 
         * @param {string} file 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setVoiceImageApiV1VoicesVoiceIdImagePut_8(voiceId: string, file: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<VoiceResponseDTO> {
            return localVarFp.setVoiceImageApiV1VoicesVoiceIdImagePut_8(voiceId, file, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a voice\'s information (catalog curation; requires \'voice:admin\').
         * @summary Update Voice
         * @param {string} voiceId 
         * @param {VoiceUpdateDTO} voiceUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVoiceApiV1VoicesVoiceIdPatch(voiceId: string, voiceUpdateDTO: VoiceUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<VoiceResponseDTO> {
            return localVarFp.updateVoiceApiV1VoicesVoiceIdPatch(voiceId, voiceUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a voice\'s information (catalog curation; requires \'voice:admin\').
         * @summary Update Voice
         * @param {string} voiceId 
         * @param {VoiceUpdateDTO} voiceUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVoiceApiV1VoicesVoiceIdPatch_9(voiceId: string, voiceUpdateDTO: VoiceUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<VoiceResponseDTO> {
            return localVarFp.updateVoiceApiV1VoicesVoiceIdPatch_9(voiceId, voiceUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VoicesApi - object-oriented interface
 * @export
 * @class VoicesApi
 * @extends {BaseAPI}
 */
export class VoicesApi extends BaseAPI {
    /**
     * Create a new voice (catalog curation; requires \'voice:admin\'). Requires a unique ElevenLabs voice ID.
     * @summary Create Voice
     * @param {VoiceCreateDTO} voiceCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicesApi
     */
    public createVoiceApiV1VoicesPost(voiceCreateDTO: VoiceCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return VoicesApiFp(this.configuration).createVoiceApiV1VoicesPost(voiceCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new voice (catalog curation; requires \'voice:admin\'). Requires a unique ElevenLabs voice ID.
     * @summary Create Voice
     * @param {VoiceCreateDTO} voiceCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicesApi
     */
    public createVoiceApiV1VoicesPost_1(voiceCreateDTO: VoiceCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return VoicesApiFp(this.configuration).createVoiceApiV1VoicesPost_1(voiceCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a voice (catalog curation; requires \'voice:admin\').  A voice that is still assigned to agents is only deleted when `replacement_voice_id` names another voice to move those agents to.
     * @summary Delete Voice
     * @param {string} voiceId 
     * @param {string | null} [replacementVoiceId] Voice that takes over all agents currently assigned to the deleted voice. Without it, deleting a voice that is still in use fails with 409 VOICE_IN_USE.
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicesApi
     */
    public deleteVoiceApiV1VoicesVoiceIdDelete(voiceId: string, replacementVoiceId?: string | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return VoicesApiFp(this.configuration).deleteVoiceApiV1VoicesVoiceIdDelete(voiceId, replacementVoiceId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a voice (catalog curation; requires \'voice:admin\').  A voice that is still assigned to agents is only deleted when `replacement_voice_id` names another voice to move those agents to.
     * @summary Delete Voice
     * @param {string} voiceId 
     * @param {string | null} [replacementVoiceId] Voice that takes over all agents currently assigned to the deleted voice. Without it, deleting a voice that is still in use fails with 409 VOICE_IN_USE.
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicesApi
     */
    public deleteVoiceApiV1VoicesVoiceIdDelete_2(voiceId: string, replacementVoiceId?: string | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return VoicesApiFp(this.configuration).deleteVoiceApiV1VoicesVoiceIdDelete_2(voiceId, replacementVoiceId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove the voice\'s portrait image (requires \'voice:admin\').
     * @summary Delete Voice Image
     * @param {string} voiceId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicesApi
     */
    public deleteVoiceImageApiV1VoicesVoiceIdImageDelete(voiceId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return VoicesApiFp(this.configuration).deleteVoiceImageApiV1VoicesVoiceIdImageDelete(voiceId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove the voice\'s portrait image (requires \'voice:admin\').
     * @summary Delete Voice Image
     * @param {string} voiceId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicesApi
     */
    public deleteVoiceImageApiV1VoicesVoiceIdImageDelete_3(voiceId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return VoicesApiFp(this.configuration).deleteVoiceImageApiV1VoicesVoiceIdImageDelete_3(voiceId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate a voice sample using ElevenLabs TTS. Returns an audio file with the provided text spoken in the selected voice.
     * @summary Generate Voice Sample
     * @param {string} voiceId 
     * @param {VoiceSampleRequestDTO} voiceSampleRequestDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicesApi
     */
    public generateVoiceSampleApiV1VoicesVoiceIdSamplePost(voiceId: string, voiceSampleRequestDTO: VoiceSampleRequestDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return VoicesApiFp(this.configuration).generateVoiceSampleApiV1VoicesVoiceIdSamplePost(voiceId, voiceSampleRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate a voice sample using ElevenLabs TTS. Returns an audio file with the provided text spoken in the selected voice.
     * @summary Generate Voice Sample
     * @param {string} voiceId 
     * @param {VoiceSampleRequestDTO} voiceSampleRequestDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicesApi
     */
    public generateVoiceSampleApiV1VoicesVoiceIdSamplePost_4(voiceId: string, voiceSampleRequestDTO: VoiceSampleRequestDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return VoicesApiFp(this.configuration).generateVoiceSampleApiV1VoicesVoiceIdSamplePost_4(voiceId, voiceSampleRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific voice by ID.
     * @summary Get Voice
     * @param {string} voiceId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicesApi
     */
    public getVoiceApiV1VoicesVoiceIdGet(voiceId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return VoicesApiFp(this.configuration).getVoiceApiV1VoicesVoiceIdGet(voiceId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific voice by ID.
     * @summary Get Voice
     * @param {string} voiceId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicesApi
     */
    public getVoiceApiV1VoicesVoiceIdGet_5(voiceId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return VoicesApiFp(this.configuration).getVoiceApiV1VoicesVoiceIdGet_5(voiceId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all available voices. Voices are global resources not tied to any organization.
     * @summary List Voices
     * @param {boolean} [activeOnly] Only return active voices
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicesApi
     */
    public listVoicesApiV1VoicesGet(activeOnly?: boolean, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return VoicesApiFp(this.configuration).listVoicesApiV1VoicesGet(activeOnly, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all available voices. Voices are global resources not tied to any organization.
     * @summary List Voices
     * @param {boolean} [activeOnly] Only return active voices
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicesApi
     */
    public listVoicesApiV1VoicesGet_6(activeOnly?: boolean, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return VoicesApiFp(this.configuration).listVoicesApiV1VoicesGet_6(activeOnly, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search voices by name.
     * @summary Search Voices
     * @param {string} name Search term for voice name
     * @param {number} [limit] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicesApi
     */
    public searchVoicesApiV1VoicesSearchGet(name: string, limit?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return VoicesApiFp(this.configuration).searchVoicesApiV1VoicesSearchGet(name, limit, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search voices by name.
     * @summary Search Voices
     * @param {string} name Search term for voice name
     * @param {number} [limit] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicesApi
     */
    public searchVoicesApiV1VoicesSearchGet_7(name: string, limit?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return VoicesApiFp(this.configuration).searchVoicesApiV1VoicesSearchGet_7(name, limit, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload (or replace) the voice\'s portrait image (requires \'voice:admin\').  Format and size limits are enforced by the service. The returned DTO includes the resulting ``image_url``.
     * @summary Set Voice Image
     * @param {string} voiceId 
     * @param {string} file 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicesApi
     */
    public setVoiceImageApiV1VoicesVoiceIdImagePut(voiceId: string, file: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return VoicesApiFp(this.configuration).setVoiceImageApiV1VoicesVoiceIdImagePut(voiceId, file, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload (or replace) the voice\'s portrait image (requires \'voice:admin\').  Format and size limits are enforced by the service. The returned DTO includes the resulting ``image_url``.
     * @summary Set Voice Image
     * @param {string} voiceId 
     * @param {string} file 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicesApi
     */
    public setVoiceImageApiV1VoicesVoiceIdImagePut_8(voiceId: string, file: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return VoicesApiFp(this.configuration).setVoiceImageApiV1VoicesVoiceIdImagePut_8(voiceId, file, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a voice\'s information (catalog curation; requires \'voice:admin\').
     * @summary Update Voice
     * @param {string} voiceId 
     * @param {VoiceUpdateDTO} voiceUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicesApi
     */
    public updateVoiceApiV1VoicesVoiceIdPatch(voiceId: string, voiceUpdateDTO: VoiceUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return VoicesApiFp(this.configuration).updateVoiceApiV1VoicesVoiceIdPatch(voiceId, voiceUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a voice\'s information (catalog curation; requires \'voice:admin\').
     * @summary Update Voice
     * @param {string} voiceId 
     * @param {VoiceUpdateDTO} voiceUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicesApi
     */
    public updateVoiceApiV1VoicesVoiceIdPatch_9(voiceId: string, voiceUpdateDTO: VoiceUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return VoicesApiFp(this.configuration).updateVoiceApiV1VoicesVoiceIdPatch_9(voiceId, voiceUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

